import React, { PropTypes } from 'react'
import Auth from '../modules/Auth';
import FacebookLogin from './FacebookLogin';
import UserService from '../services/UserService';


class FacebookLoginContainer extends React.Component {

	constructor(props,context){
		super(props,context);
		//console.log(context);


	}

	onStatusChange(response) {
      //console.log( response );
      var self = this;

      if( response.status === "connected" ) {

         FB.api('/me',{fields:'id,name,email'}, function(response) { // eslint-disable-line no-undef
				 			let params = {name:response.name, facebook_id: response.id, email: response.email}

						if(params.email == null || params.email == ''){
								params.email = 'no_mail';
						}
						Auth.saveFacebookUser(JSON.stringify(params));
						UserService.createPlayer(params);
            var message = "Welcome " + response.name;
            self.context.router.replace('/');

         });

      }else{
          Auth.removeFacebookUser();
      }
   }


	componentDidUpdate() {
		console.log('se update...');
    	if (window.FB) {
     	 	window.FB.XFBML.parse();
     	 	this.FB = window.FB;
      			this.FB.Event.subscribe('auth.statusChange',
         		this.onStatusChange.bind(this));
    	}
  	}

	render(){
		return(
			<div>
				<FacebookLogin  appId='401225480247747' onStatusChange={this.onStatusChange.bind(this)} />
		</div>
		)
	}

}

FacebookLoginContainer.contextTypes = {
  router: PropTypes.object.isRequired
};


export default FacebookLoginContainer;



// WEBPACK FOOTER //
// ./src/components/FacebookLoginContainer.js